import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { getModule } from 'vuex-module-decorators'
import UserModule from '@/store/userModule.ts'
import ExtensionModule from '@/store/extensionModule.ts'
import TitleModule from '@/store/titleModule.ts'

Vue.config.productionTip = false

Vue.filter('formatNewLines', (value: string) => {
  if (!value) return ''
  return value.replace(/\\n/g, '\n')
})

new Vue({
  router,
  store,

  created() {
    const userString: string | null = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      const userModule = getModule(UserModule)
      userModule.setUserData(userData)
    }

    const extensionString: string | null = localStorage.getItem('extension')
    if (extensionString) {
      const extensionData = JSON.parse(extensionString)
      const extensionModule = getModule(ExtensionModule)
      extensionModule.setExtension(extensionData)
    }

    const titleString: string | null = localStorage.getItem('title')
    if (titleString) {
      const titleData = JSON.parse(titleString)
      const titleModule = getModule(TitleModule)
      titleModule.setPageTitle(titleData)
    }
  },

  vuetify,
  render: h => h(App)
}).$mount('#app')
